module.exports = __webpack_public_path__ + "media/images/logo-black-674a7d28a5983c2bf6355a829f746bbf.png";